import { useLocalSearchParams } from 'expo-router';

import { TenantEventsScreen } from '@/components/events/tenant-events-screen';

export default function PublicEventsRoute() {
  const { tenant: tenantSlug } = useLocalSearchParams<{ tenant: string }>();

  return (
    <TenantEventsScreen
      eventHref={(tenant, event) => ({
        pathname: '/[tenant]/events/[id]',
        params: { tenant: tenant.slug, id: event.id },
      })}
      tenantSlug={tenantSlug}
    />
  );
}
